import React, { useMemo } from 'react';
import { Preloader } from '@common-fe/common-fe';

import { LMNPopupMode } from '../../../LettersOfMedicalNecessity.types';

interface Params {
  mode: LMNPopupMode;
  fileName?: string;
  isLoading?: boolean;
  createForClaimId?: string;
}
const useDocumentPreviewNodes = ({ mode, fileName = '', isLoading, createForClaimId }: Params) => {
  const title = useMemo(() => {
    if (mode === LMNPopupMode.UPLOAD || mode === LMNPopupMode.CONVERT) {
      return 'Add a New Letter of Medical Necessity';
    }
    if (mode === LMNPopupMode.EDIT || mode === LMNPopupMode.PARTIAL_EDIT) {
      return `Edit ${fileName}`;
    }
    if (mode === LMNPopupMode.VIEW) {
      return fileName;
    }
  }, [mode, fileName]);

  const nextButtonTitle = useMemo(() => {
    if (isLoading) {
      return <Preloader color="white" />;
    }

    if (createForClaimId) {
      return 'Submit';
    }

    return 'Submit';
  }, [isLoading, createForClaimId]);
  return {
    title,
    nextButtonTitle,
  };
};

export default useDocumentPreviewNodes;
